import { HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DocumentsService } from 'src/app/service/common/documents.service';
import { MyFile } from 'src/app/service/common/interface';
import { MessageService } from 'src/app/service/common/message.service';
import { SupportService } from 'src/app/service/common/support.service';

@Component({
  selector: 'app-document-modal',
  templateUrl: './document-modal.component.html',
  styleUrls: ['./document-modal.component.css']
})
export class DocumentModalComponent implements OnInit {

  private _subscription : Subscription = new Subscription();
  documentTypeData : any;
  selectedFile : MyFile[];
  UploadProgress: number;
  index : number;
  constructor(
    private documentService : DocumentsService,
    private supportService : SupportService,
    private matDialog : MatDialogRef<DocumentModalComponent>,
    private msgService : MessageService,
    @Inject(MAT_DIALOG_DATA) public data : any,
  ) { 
    this.selectedFile = [];
    this.index = 0;
    matDialog.disableClose = true;
  }

  ngOnInit() {
    this._subscription.add(
      this.supportService.getNames('documentTypes').subscribe(res => {
        this.documentTypeData = res.data;
      })
    )
  }

  closeModal(){
    this.matDialog.close(false);
  }

  uploadFiles($event){
    if($event.addedFiles.length > 0){
      let count = 0;
      while(count < $event.addedFiles.length){
        let temp : MyFile = {
          'index' : this.index,
          'name' : $event.addedFiles[count],
          'type' : ""
        }
        this.selectedFile.push(temp);
        count ++;
        this.index ++;
      }
    }
  }

  deleteSelectedFile(i){
    this.selectedFile = this.selectedFile.filter(file => file.index !== i);
  }



  saveDocument(){
    if(this.selectedFile.length > 0){
      const formData = new FormData();
      
      formData.append("modelId", this.data.modelId);
      formData.append("modelName", this.data.modelName);

      this.selectedFile.forEach(fileData => {
        formData.append('file[]', fileData.name);  
        formData.append('type[]', fileData.type);     
      });
      this._subscription.add(
        this.documentService.saveDocument(formData).subscribe(
          event => {
            if(event.type === HttpEventType.UploadProgress){
              this.UploadProgress = Math.round((event.loaded / event.total) * 100);
            } else if(event.type === HttpEventType.Response) {
              let response: any;
              response = event.body;
              // console.log(response);
              if(response.status == "ok"){
                this.matDialog.close(response);
                this.msgService.success(response.message);
              }else{
                this.msgService.error(response.message);
              }
            }
          }
        )
      )
    }else {
      this.msgService.error("Please select at least one File!");
    }
  }

  ngOnDestroy(){
    this._subscription.unsubscribe();
  }

}
